import React, { useEffect, useState } from "react";
import PublicProfileForm from "../../components/combinations/PublicProfileForm";
import styled from "styled-components";
import UserHead from "../../config/UserHead";
import Visitor from "../../components/layouts/Visitor";
import { api } from "../../../api";
import { GetPublicProfile200Response } from "../../../api/v1";
import NoUserImage from "../../assets/images/no_user_image.webp";

const PublicProfileStyle = styled.div`
  background: white;
  border-radius: 25px;
  padding: 20px 30px;
  margin: 30px;

  @media (max-width: 767px) {
    padding: 20px 10px;
    margin: 30px 10px;
  }
`;

const PublicProfile: React.FC = () => {
  const username = location.pathname.split("/").pop();
  const [imageUrl, setImageUrl] =
    useState<GetPublicProfile200Response["imageUrl"]>();
  const [badges, setBadges] = useState<GetPublicProfile200Response["badges"]>(
    []
  );

  useEffect(() => {
    api.getPublicProfile(username).then((response) => {
      setImageUrl(response.data.imageUrl);
      setBadges(response.data.badges);
    });
  }, []);

  return (
    <Visitor>
      <UserHead title="プロフィール" />
      <PublicProfileStyle>
        <PublicProfileForm
          username={username}
          imageUrl={String(imageUrl || NoUserImage)}
          badges={badges}
        />
      </PublicProfileStyle>
    </Visitor>
  );
};
export default PublicProfile;
